import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { i18next } from '@yola/ws-sdk';
import { designSystem } from '@yola/ws-ui';
import { GALLERY_ITEM_INDENT } from '../constants/common';

const { Icon, Paragraph, SelectedIcon } = designSystem;

function StockGalleryItem({
  id,
  src,
  width,
  height,
  alt = '',
  info = null,
  isSelected,
  isSearching = false,
  isMobile = false,
  onClick,
}) {
  const [isLoaded, setLoadedStatus] = useState(false);

  const computedWidth = width - GALLERY_ITEM_INDENT;
  const computedHeight = height - GALLERY_ITEM_INDENT;

  const itemClasses = classNames('ws-stock-gallery-item', {
    'ws-stock-gallery-item--loaded': isLoaded && !isSearching,
    'ws-stock-gallery-item--active': isSelected,
    'ws-stock-gallery-item--mobile': isMobile,
  });

  const handleLoad = useCallback(() => {
    setLoadedStatus(true);
  }, []);

  return (
    <div className={itemClasses} style={{ width: computedWidth, height: computedHeight }}>
      <div
        className="ws-stock-gallery-item__image"
        onClick={(e) => {
          onClick(id, e);
        }}
      >
        <img
          src={src}
          width={computedWidth}
          height={computedHeight}
          alt={alt}
          loading="lazy"
          onLoad={handleLoad}
        />
      </div>
      {info && (
        <div className="ws-stock-gallery-item__caption">
          <div className="ws-stock-gallery-item__info-icon">
            <Icon glyph="info-italic" type="white" />
          </div>
          <div className="ws-stock-gallery-item__content">
            <Paragraph appearance="white">
              <span
                // eslint-disable-next-line yola/react/no-danger
                dangerouslySetInnerHTML={{
                  __html: i18next.t('Photo by {userLink} on {unsplashLink}', {
                    userLink: `<a href=${info.authorLink} target="_blank">${info.authorName}</a>`,
                    unsplashLink: `<a href=${info.stockLink} target="_blank">${info.stockName}</a>`,
                  }),
                }}
              />
            </Paragraph>
          </div>
        </div>
      )}
      {isSelected && (
        <div className="ws-stock-gallery-item__selected-icon">
          <SelectedIcon />
        </div>
      )}
    </div>
  );
}

StockGalleryItem.propTypes = {
  id: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  alt: PropTypes.string,
  info: PropTypes.shape({
    authorName: PropTypes.string,
    authorLink: PropTypes.string,
    stockLink: PropTypes.string,
    stockName: PropTypes.string,
  }),
  isSelected: PropTypes.bool.isRequired,
  isSearching: PropTypes.bool,
  isMobile: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default StockGalleryItem;
